import {useContext, useEffect, useState} from "react";
import SiteService from "../services/SiteService";
import {Link} from "react-router-dom";
import userContext from "../store/userContext";
import Loginbox from "../components/ui/functional/Loginbox";

export default function VerifyEmail(){

	const [isSending, setIsSending] = useState(false);
	const [isSent, setIsSent] = useState(false);

	const user = useContext(userContext);

	useEffect(()=>{
		//console.log(user)
		if(user.isVerified === true){
			window.location = "/";
		}
	},[user.awaitVerification])

	const requestVerificationEmail = async () => {try {
		setIsSending(true);
		const response = await fetch(SiteService.apiPath + '/user/requestverificationemail');
		const data = await response.json();

		if (data.verified) {
			window.location = window.location;
			return; // stop further execution
		}

		if (data.success === false) {
			// Handle failure case if needed
		}

		if (data.success) {
			setIsSent(true);
		}
	} catch (err) {
		console.log(err);
		alert('Feil under sending av epost');
	} finally {
		setIsSending(false);
	}};

	async function logout() {try {
		if (!confirm('Logg ut?')) {
			return;
		}
		const response = await fetch(`${SiteService.apiPath}/user/logout`);
		const data = await response.json();
		if (data.success) {
			if (data.destination) {
				return window.location = data.destination;
			}
			window.location = window.location; // refresh
		} else {
			confirm('Feil under utlogging');
		}
	} catch (error) {
		console.error(error);
		confirm('Feil under utlogging');
	}}

	if (user.isVerified && !user.isLoggedIn) return <a href={'/login'}>Login</a> ;
return(<>
	<div style={{textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
		<h3>Du må verifisere din e-post adresse før brukeren din kan benyttes.</h3>
		<p>Sjekk søppelpost/spam dersom du ikke finner eposten i din innboks.</p>
		<div><i>Ikke fått eposten?</i></div>
		{isSent ? <div><br/><b>Sendt!<br/>Husk å sjekke søppelpost om du ikke finner eposten</b></div> :
			!isSending ?
			<Link to={""} onClick={requestVerificationEmail}>Send ny verifikasjonslenke til epost</Link>
			:
			<div>Sender ny e-post...</div>
		}
		<br/>

		{(user.isLoggedIn && !user.isVerified)&&<><div style={{marginTop:'1em'}}>Logget inn som <b>{user.email}</b></div>
		<br/>
		<button className={'button1'} onClick={logout}>Logg ut</button></>}
	</div>
</>)}